export default "__VITE_ASSET__gLrTgsbD__"